module.exports = __webpack_public_path__ + "img/ic_shuttle.2628ce8a.svg";